// Reine Note-Helfer des Harmonika-Widgets. EINZIGE Quelle – geteilt von der Griff-Visualisierung
// (Inspector) UND dem Keyboard-Simulator (`webapp/src/features/keyboard/`, nutzt `midiToFreq`).
// Der Oktav-Offset +3 und die Regex halten die abgeleiteten MIDI-Werte 1:1 mit der Python-Engine
// im Einklang (siehe tests/test_button_table_alignment.py).

const NOTE_BASE: Record<string, number> = {
  C: 0,
  D: 2,
  E: 4,
  F: 5,
  G: 7,
  A: 9,
  B: 11,
}

/** Parst einen Notenstring (z.B. "A-2", "C#2", "F#0") zu einer MIDI-Nummer (Oktav-Offset +3). */
export function parseNoteStr(noteStr: string): number | null {
  const match = noteStr.match(/^([A-G])([#-]*)(-?\d+)$/)
  if (!match) return null

  const noteName = match[1]?.toUpperCase()
  const accidentals = match[2]
  const octaveStr = match[3]
  if (noteName === undefined || accidentals === undefined || octaveStr === undefined) return null

  let octave = Number.parseInt(octaveStr, 10)

  octave += 3

  let semitone = NOTE_BASE[noteName]
  if (semitone === undefined) return null
  for (const char of accidentals) {
    if (char === '#') semitone += 1
    if (char === '-') semitone -= 1
  }

  return (octave + 1) * 12 + semitone
}

/** Anzeige-Formatierung: '-' → 'b', Oktavziffern entfernen (z.B. "A-2" → "Ab"). */
export function formatNoteForDisplay(noteStr: string): string {
  return noteStr.replace(/-/g, 'b').replace(/(\d)/g, '')
}

/**
 * Anzeige-Formatierung MIT Oktave: '-' → '♭', '#' → '♯' (z.B. "B-3" → "B♭3", "F#4" → "F♯4").
 * Gegenstück zu `formatNoteForDisplay`, das die Oktave bewusst entfernt. Genutzt von der
 * Info-Zeile des `NoteActionsOverlay` für die klingenden Töne aus `POST /api/note-grips`.
 * KEINE Oktav-Umrechnung: `sounding_notes` steht in music21-Konvention (C4 = mittleres C), der
 * `octave += 3`-Offset in `parseNoteStr` gilt nur für die MIDI-Ableitung des Simulators.
 */
export function formatNoteWithOctaveForDisplay(noteStr: string): string {
  return noteStr.replace(/-/g, '♭').replace(/#/g, '♯')
}

/**
 * MIDI-Nummer → Frequenz in Hz. Basis A4 = 432 Hz (bewusst 432, nicht 440) – genutzt vom
 * Keyboard-Simulator (`features/keyboard`) für die Musette-Synthese. Für die reine Griff-
 * Visualisierung ohne Ton irrelevant, aber Teil desselben Notenmodells.
 */
export function midiToFreq(midi: number): number {
  return 432 * 2 ** ((midi - 69) / 12)
}
